export const examAdminShell = {
  sectionLabel: "管理ポータル",
  brandSubtitle: "AI を活用した評価システムの管理画面",
  menu: {
    dashboard: "ダッシュボード",
    staffUsers: "試験運営スタッフ",
    candidateUsers: "受験者",
    systemSettings: "システム",
    rolePermissions: "ロール権限",
    customFields: "カスタム項目",
    assetsCenter: "アセット",
    auditLogs: "監査ログ",
    auditLoginLogs: "ログインログ",
    auditOperationLogs: "操作ログ",
    questions: "問題",
    papers: "試験用紙",
    exams: "試験",
    execution: "実行管理",
    submissions: "コード提出記録",
    dockerImages: "イメージ",
    dockerInstances: "インスタンス",
    review: "採点",
    aiTasks: "AI タスク",
  },
  breadcrumbs: {
    home: "管理ポータル",
    dashboard: "ダッシュボード",
    staffUsers: "試験運営スタッフ",
    candidateUsers: "受験者",
    systemSettings: "システム",
    rolePermissions: "ロール権限",
    customFields: "カスタム項目",
    assetsCenter: "アセット",
    auditLogs: "監査ログ",
    auditLoginLogs: "ログインログ",
    auditOperationLogs: "操作ログ",
    questions: "問題",
    papers: "試験用紙",
    exams: "試験",
    execution: "実行管理",
    submissions: "コード提出記録",
    dockerImages: "イメージ",
    dockerInstances: "インスタンス",
    review: "採点",
    aiTasks: "AI タスク",
  },
  routes: {
    businessGroup: "主要業務フロー",
    organizationGroup: "ユーザーと組織",
    resourceGroup: "リソースと環境",
    platformGroup: "システムと監査",
    userGroup: "ユーザー管理",
    systemGroup: "システム管理",
    dockerGroup: "イメージ・コンテナ管理",
    auditAll: "全ログ",
    questionDetail: "問題詳細",
    manualPaperPicker: "手動選題ワークベンチ",
    paperDetail: "試験用紙詳細",
    examDetail: "試験詳細",
    attemptDetail: "受験詳細",
    dockerInstanceDetail: "インスタンス詳細",
  },
  preferences: {
    entry: "個人設定",
    title: "個人設定",
    actions: {
      reset: "デフォルトに戻す",
    },
    fields: {
      locale: "言語",
      navTheme: "ナビテーマ",
      layout: "レイアウト",
      contentWidth: "コンテンツ幅",
      colorPrimary: "テーマカラー",
      fixedHeader: "ヘッダー固定",
      fixSiderbar: "サイドバー固定",
      splitMenus: "メニュー分割",
      colorWeak: "色弱モード",
    },
    options: {
      navThemeSystem: "システムに追従",
      navThemeLight: "ライト",
      navThemeDark: "ダーク",
      layoutMix: "ミックス",
      layoutSide: "サイド",
      layoutTop: "トップ",
      contentFluid: "可変",
      contentFixed: "固定",
    },
  },
};
